<div *ngFor="let updatedChannel of changes | keyvalue" class="panel-container">
    <div class="panel-title-wrapper">
        <div class="panel-title">
            {{ updatedChannel.key }}
        </div>
        <div>{{ updatedChannel.value.group }}</div>
        <div>{{ updatedChannel.value.category }}</div>
    </div>
    <div *ngFor="let update of updatedChannel.value.changes" class="change-container">
        {{ update.change }}
        <div class="change">
            <div>"{{ update.old }}"</div>
            <mat-icon svgIcon="arrow-right" class="arrow-icon" />
            <div>"{{ update.new }}"</div>
        </div>
    </div>
</div>
